(function() {
    if (!(document.cookie.indexOf("cf_cookie") >= 0)) {
        // check if cookie consent should be set automatically
        if (document.getElementById('content').classList.contains('analytics_enabled')) {
            const oneYearFromNow = new Date();
            oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
            const oneYearFromNowUtc = oneYearFromNow.toUTCString();
            document.cookie = 'cfcookiemanager=1; expires=' + oneYearFromNowUtc + '; path=/';
        }

        if (!(document.cookie.indexOf("cfcookiemanager") >= 0)) {
            // set cookie
            const oneYearFromNow = new Date();
            oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
            const oneYearFromNowUtc = oneYearFromNow.toUTCString();
            document.cookie = 'cf_cookie={"categories":["cfcookiemanager"],"level":["cfcookiemanager"],"revision":1,"data":null,"rfc_cookie":false,"consent_date":"' + (new Date()).toISOString() + '","consent_uuid":"c12c1848-11d8-4145-8e13-a886de9ed18e","last_consent_update":"' + (new Date()).toISOString() + '"};secure;SameSite=Lax;Domain=.' + window.location.hostname + ';expires=' + oneYearFromNowUtc + '; path=/';
            document.addEventListener('DOMContentLoaded', function() {
                window.cc.accept(['cfcookiemanager']);
            });
        }

        document.addEventListener('DOMContentLoaded', function() {
            const consentButton = document.querySelector('.c-bn.c_settings');
            if(consentButton) {
                consentButton.click();
                document.getElementById('cc--main').addEventListener("click", function (e) {
                    if (!(document.cookie.indexOf("cf_cookie") >= 0)) {
                        if(e.key === 'Escape' || e.keyCode === 27) {
                            document.getElementById('c-t-bn').click();
                        }
                        if(e.target.id === 'c-s-in' || e.target.id === 'cs') {
                            document.getElementById('c-t-bn').click();
                        }
                    }
                });
                if (!(document.cookie.indexOf("cf_cookie") >= 0)) {
                    document.getElementById('s-c-bn')?.classList.add("d-none");
                }

                document.querySelectorAll('#s-bns .c-bn').forEach(function(button) {
                    button.addEventListener("click", function (e) {
                        document.getElementById('s-c-bn')?.classList.remove("d-none");
                    });
                });

                document.addEventListener('keydown',function(e) {
                    if (!(document.cookie.indexOf("cf_cookie") >= 0)) {
                        if(e.key === 'Escape' || e.keyCode === 27) {
                            document.getElementById('c-t-bn').click();
                        }
                        if(e.target.id === 'c-s-in' || e.target.id === 'cs') {
                            document.getElementById('c-t-bn').click();
                        }
                    }
                });

                removeAriaHidden();
            }

            document.querySelectorAll('.cookie-item').forEach(function(cookieItem) {
                // add tabindex = 0 to make it focusable
                cookieItem.setAttribute('tabindex', '0');
                cookieItem.setAttribute('role', 'button');
                cookieItem.addEventListener('keydown', function(e) {
                    if (e.key === 'Enter' || e.keyCode === 13 || e.key === " " || e.code === "Space" || e.keyCode === 32) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        // get next sibling of cookieItem
                        const nextSibling = cookieItem.nextElementSibling;
                        nextSibling.classList.toggle('cookie-description-active');
                    }
                });
            });
        });

    }
})();

function removeAriaHidden() {
    document.querySelectorAll('.desc,.cfwrapper').forEach(function(desc) {
        if(desc.hasAttributes('aria-hidden')) {
            desc.removeAttribute('aria-hidden');
        }
        desc.addEventListener('click', function(e) {
            if(this.hasAttributes('aria-hidden')) {
                this.removeAttribute('aria-hidden');
            }
        });
    });

    document.querySelectorAll('.block-section .b-tl').forEach(function(button) {
        button.addEventListener('click', function(e) {
            const element = this.parentElement.nextSibling;
            if(element.hasAttributes('aria-hidden')) {
                element.removeAttribute('aria-hidden');
            }
        });
    });
}
document.addEventListener('DOMContentLoaded', function() {
    removeAriaHidden();
    document.querySelectorAll('.cc-s-btn')[0]?.addEventListener('click', function(e) {
        setTimeout(function() {
            removeAriaHidden();
        }, 200);
    });

    const acceptServiceButton = document.querySelectorAll('.c-la-b, .c-l-b');
    acceptServiceButton.forEach(function(button) {

        button.addEventListener('click', function(e) {
            // find parent with class
            const service = button.closest('[data-service]').getAttribute('data-service');
            if(service) {
                const accepted_categories = window.cc.getUserPreferences().accepted_categories;
                if(accepted_categories.length > 0) {
                    window.cc.accept([...accepted_categories, service]);
                } else {
                    window.cc.accept([service]);
                }
            }
        });
    });

    const providerLinks = document.querySelectorAll('tr.cookie-item > td > a');
    setTimeout(function() {
        providerLinks.forEach(function(link) {
            if(link.innerHTML === 'Provider') {
                link.remove();
            }
        });
    }, 1500);

    const tableHeaders = document.querySelectorAll('.cf-category-wrapper table tr > th');
    tableHeaders.forEach(function(header) {
        if(header.innerHTML === '') {
            header.remove();
        }
    });
});